<div class="ftcf-canvas-wrapper">
  <div class="ftcf-canvas-title">
    <span class="ftcf-canvas-title-text">{{ title }}</span>
    <div class="ftcf-canvas-zoom">
      <button type="button" class="ftcf-canvas-zoom-btn" (click)="zoomOut()" title="Diminuir zoom">
        <i class="pi pi-minus"></i>
      </button>
      <button type="button" class="ftcf-canvas-zoom-btn ftcf-canvas-zoom-reset" (click)="resetZoom()" title="Redefinir zoom">
        {{ (zoom * 100) | number: '1.0-0' }}%
      </button>
      <button type="button" class="ftcf-canvas-zoom-btn" (click)="zoomIn()" title="Aumentar zoom">
        <i class="pi pi-plus"></i>
      </button>
    </div>
  </div>
  <div class="ftcf-canvas-scroll"
       [class.panning]="isPanning"
       (wheel)="onWheel($event)"
       (pointerdown)="onPanStart($event)">
    <svg [attr.viewBox]="svgViewBox"
         [attr.width]="svgWidth * zoom"
         [attr.height]="svgHeight * zoom"
         [style.transform]="'translate(' + panX + 'px, ' + panY + 'px)'"
         class="ftcf-canvas-svg">
      <defs>
        <marker id="ftcf-arrow" markerWidth="8" markerHeight="8" refX="6" refY="3" orient="auto">
          <path d="M0,0 L0,6 L8,3 z" fill="#888" />
        </marker>
      </defs>
      <g *ngFor="let edge of layoutEdges">
        <polyline
          [attr.points]="edge.points | ftcfPoints"
          fill="none"
          stroke="#888"
          stroke-width="1.5"
          marker-end="url(#ftcf-arrow)" />
      </g>
      <g *ngFor="let node of layoutNodes">
        <rect
          [attr.x]="node.x"
          [attr.y]="node.y"
          [attr.width]="NODE_W"
          [attr.height]="NODE_H"
          rx="6"
          class="ftcf-node-rect" />
        <text
          [attr.x]="node.x + NODE_W / 2"
          [attr.y]="node.y + 28"
          text-anchor="middle"
          class="ftcf-node-type">
          {{ getNodeTypeName(node.nodeType) }}
        </text>
        <text
          [attr.x]="node.x + NODE_W / 2"
          [attr.y]="node.y + 52"
          text-anchor="middle"
          class="ftcf-node-label">
          {{ node.label }}
        </text>
      </g>
    </svg>
  </div>
</div>
